import { Card } from "antd";
import moment from "moment";
import { FaClipboardList, FaInfoCircle, FaRegCheckCircle, FaRegClock, FaShoppingCart, FaUserMd } from "react-icons/fa";
import IReservationsTimeLineItemProps from "components/ReservationsTimeLineItems/IReservationsTimeLineItemProps";
import { IDettagliPrenotazioneExt, IPrenotazioneExt, OccupazionuEnum } from "core/interfaces/data/IAssistitoRequest";
import "./ReservationsTimeLine.css";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import CustomButton from "components/CustomButton/CustomButton";
import { Enhanced } from "utils/ReactUtils";
import _ from "lodash";

const ReservationsTimeLine: React.FC<IReservationsTimeLineItemProps> = ({ item, onClick, onInfoClick, abilitaPagamento = false, t, descrizioni }) => {
	let date = item[0];
	let prenotazioni: IPrenotazioneExt[] = item[1];
	let today = moment().startOf("day");
	let dateRifDay = moment(date, "DD/MM/YYYY").startOf("day");

	let groupDateTextWeekday = moment(date, "DD/MM/YYYY").toDate().toTextWeekday(true);
	let groupDateRelativeDayText = (() => {
		switch (today.diff(dateRifDay, "day")) {
			case 0: {
				return t("giorniCalendario.oggi");
			}
			case 1: {
				return t("giorniCalendario.ieri");
			}
			case -1: {
				return t("giorniCalendario.domani");
			}
		}

		return "";
	})();

	const dettagliPrenotazioniGet = () => {
		let dettagliPreventivo = _.map(prenotazioni, (p) => {
			return {
				IdCodPaiPreventivo: p.IdCodPaiPreventivo,
				DsOccupazione: p.DsOccupazione,
				DsOperatore: p.DsOperatore,
				OccupazioneDa: p.OccupazioneDa,
				OccupazioneA: p.OccupazioneA,
			};
		});
		let preventiviPrestazioni = _.groupBy(dettagliPreventivo, "IdCodPaiPreventivo");

		let prenotazioniExt: IDettagliPrenotazioneExt[] = _.map(prenotazioni, (p) => {
			var res: IDettagliPrenotazioneExt = {
				IdCodPaiPreventivo: p.IdCodPaiPreventivo,
				IdEntita: p.IdEntita,
				DsEntita: p.DsEntita,
				IguAttivita: p.IguAttivita,
				Matricola: p.Matricola,
				NomeAssistito: p.NomeAssistito,
				CognomeAssistito: p.CognomeAssistito,
				IdPersRif: p.IdPersRif,
				NomePersRif: p.NomePersRif,
				CognomePersRif: p.CognomePersRif,
				StatoOccupazione: p.StatoOccupazione,
				Pagato: p.Pagato,
				IguTipoPagamento: p.IguTipoPagamento,
				DsTipoPagamento: p.DsTipoPagamento,
				GroupByString: p.GroupByString,
				GroupByDate: p.GroupByDate,
				PrestazioniDaErogare: _.map(preventiviPrestazioni[p.IdCodPaiPreventivo], (prest) => {
					return {
						IguAttivita:p.IguAttivita,
						Prestazione: prest.DsOccupazione,
						Operatore: prest.DsOperatore,
						OccupazioneDa: prest.OccupazioneDa,
						OccupazioneA: prest.OccupazioneA,
					};
				}),
			};
			return res as IDettagliPrenotazioneExt;
		});
		var res = _.uniqBy(prenotazioniExt, "IdCodPaiPreventivo");
		return res;
	};

	const onCardClick = (IdCodPaiPreventivo: number) => {
		if (onClick) {
			onClick(IdCodPaiPreventivo);
		}
	};

	return (
		<>
			<span className="reservation-timeline-title">{`${groupDateRelativeDayText} ${groupDateTextWeekday} ${date}`}</span>

			{dettagliPrenotazioniGet().map((res, index) => {
				return (
					<Card key={`card.${date}|${index}`} className="reservations-timeline-card">
						<div className="reservation-card-detils card-title">
							<span className="reservation-card-titles">
								{res.CognomeAssistito + " " + res.NomeAssistito}{" "}
								{res.StatoOccupazione === OccupazionuEnum.consuntivata && <FaRegCheckCircle className={`timeline-ico registered`}></FaRegCheckCircle>}
							</span>
						</div>
						<div className="reservation-card-detils card-content">
							{res.PrestazioniDaErogare.map((prestazione, i) => (
								<div key={`dettaglio-${i}`} className="reservation-card-detils-info">
									<div className="reservation-card-detils">
										<span className="reservation-card-item">
											<div>
												<FaClipboardList></FaClipboardList>
											</div>
											<div> {prestazione.Prestazione} </div>
											<div>
												<FaInfoCircle
													tabIndex={0}
													role="button"
													aria-label="show description"
													className={`icona-info-attivita ${descrizioni?.some(el=>el.IguAttivita===prestazione.IguAttivita)?"esistente":""}`}
													onClick={() => {
														if (onInfoClick !== undefined) onInfoClick(res.IguAttivita);
													}}
													onKeyUp={(ev: any) => {
														if (ev.code.toLowerCase() === "enter") if (onInfoClick !== undefined) onInfoClick(res.IguAttivita);
													}}
												/>
											</div>
										</span>
										<span className="reservation-card-item">
											<div>
												<FaUserMd></FaUserMd>
											</div>
											<div> {prestazione.Operatore}</div>
										</span>
									</div>
									<div className="reservation-card-time">
										<div style={{ marginRight: "5px" }}>
											<div style={{ marginLeft: "5px" }}>
												<FaRegClock></FaRegClock>
											</div>
										</div>

										<div>
											{moment(prestazione.OccupazioneDa).format("LT")} - {moment(prestazione.OccupazioneA).format("LT")}
										</div>
									</div>
								</div>
							))}
						</div>
						<div className="reservation-card-detils card-footer">
							{!abilitaPagamento && (
								<div>
									{
										<span className={`payment-text ${res.Pagato ? "paid" : "to-pay"}`}>
											{t("reservedArea.prenotazioniInsoluteUtente.descriptionText")}
										</span>
									}
								</div>
							)}

							<div>
								{abilitaPagamento && (
									<CustomButton
										buttonType={CustomButtonType.positive}
										text={t("reservedArea.prenotazioniInsoluteUtente.PagaOra")}
										icon={<FaShoppingCart />}
										OnClick={() => onCardClick(res.IdCodPaiPreventivo)}
									></CustomButton>
								)}
							</div>
						</div>
					</Card>
				);
			})}
		</>
	);
};

export default Enhanced(ReservationsTimeLine,{componentNamespace:"ReservationsTimeLine"});
